import { Spinner } from "@wordpress/components";
import { css } from "@/utils/css";

type ButtonProps = React.HTMLProps<HTMLButtonElement> & {
    children: React.ReactNode;
    loading?: boolean;
    variant?: "primary" | "secondary" | "danger";
    small?: boolean;
};

export function Button({ children, loading = false, type, className = "", variant = "primary", small = false, disabled, ...props }: ButtonProps) {
    return (
        <button
            type={type as any}
            className={css(`btn btn-${variant}`, small ? "btn-sm" : "", loading ? "cursor-not-allowed" : "cursor-pointer", className)}
            disabled={loading || disabled}
            {...props}
        >
            {loading ? <Spinner className={css("spinner")} /> : children}
        </button>
    );
}

type ButtonGroupProps = { children: React.ReactNode; className?: string } & React.HTMLProps<HTMLDivElement>;

export function ButtonGroup({ children, className = "", ...props }: ButtonGroupProps) {
    return (
        <div className={css("btn-group", className)} {...props}>
            {children}
        </div>
    );
}
